import moment from 'moment'
import 'moment/locale/ru'
import Vue from 'vue'

Vue.use(require('vue-moment'), { moment })
